import { render, staticRenderFns } from "./HotspotSelection.vue?vue&type=template&id=4c07a236&"
import script from "./HotspotSelection.vue?vue&type=script&lang=js&"
export * from "./HotspotSelection.vue?vue&type=script&lang=js&"
import style0 from "./HotspotSelection.vue?vue&type=style&index=0&id=4c07a236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports